import { formatDateForServer } from 'core/utils';
import { PricingProfilePricingType } from 'pricing/enums';
import { IPricingProfile, IPricingProfileForm } from 'pricing/types';

export const mapUpsertPricingProfile = (
  type: PricingProfilePricingType,
  data: IPricingProfileForm
) => ({
  pricingProfile: {
    name: data.name,
    agreementId: data.agreementId,
    shareAccess: data.shareAccess ? 1 : 0,
    pricingType: type,
    startDate: formatDateForServer(data.startDate),
    endDate: formatDateForServer(data.endDate),
  },
});

export const mapUpdatePricingProfiles = (
  pricingProfiles: IPricingProfile[],
  data: IPricingProfileForm
) => {
  const isSingleProfile = pricingProfiles.length === 1;

  return {
    pricingProfiles: pricingProfiles.map((profile) => ({
      id: profile.id,
      ...(isSingleProfile && data.name && { name: data.name }),
      agreementId: data.agreementId,
      startDate: formatDateForServer(data.startDate, undefined, null),
      endDate: formatDateForServer(data.endDate, undefined, null),
      ...(data.shareAccess && { shareAccess: 1 }),
    })),
  };
};
